module.exports = __webpack_public_path__ + "media/solidmap-mp4.ebb7c3de.mp4";